// ./src/components/features/Forms/FormFieldsEditModal/CreditCardFieldOptionsEditor.tsx
import React from "react";
import { Stack, Switch, MultiSelect, Text } from "@mantine/core";
import { CreditCardFieldOptions } from "./fieldOptionsTypes";

export interface CreditCardFieldOptionsEditorProps {
  value: CreditCardFieldOptions;
  onChange: (options: CreditCardFieldOptions) => void;
}

const CARD_TYPES = [
  { value: "visa", label: "Visa" },
  { value: "mastercard", label: "Mastercard" },
  { value: "amex", label: "American Express" },
  { value: "discover", label: "Discover" },
  { value: "diners", label: "Diners Club" },
  { value: "jcb", label: "JCB" },
  { value: "unionpay", label: "UnionPay" },
];

export const CreditCardFieldOptionsEditor: React.FC<
  CreditCardFieldOptionsEditorProps
> = ({ value, onChange }) => {
  const handleChange = (
    field: keyof CreditCardFieldOptions,
    fieldValue: any
  ) => {
    onChange({
      ...value,
      [field]: fieldValue,
    });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Configure credit card validation options.
      </Text>

      <MultiSelect
        label="Allowed Card Types"
        placeholder="All card types"
        description="Leave empty to allow all card types"
        data={CARD_TYPES}
        value={value.allowedTypes ?? []}
        onChange={(types) =>
          handleChange("allowedTypes", types.length > 0 ? types : undefined)
        }
        clearable
        searchable
        size="sm"
      />

      <Switch
        label="Return card type"
        description="Include detected card type (Visa, Mastercard, etc.) in submission data"
        checked={value.returnCardType ?? false}
        onChange={(e) =>
          handleChange("returnCardType", e.currentTarget.checked)
        }
        size="sm"
      />

      <Switch
        label="Mask card number"
        description="Store only last 4 digits (e.g., ****1234)"
        checked={value.maskNumber ?? true}
        onChange={(e) => handleChange("maskNumber", e.currentTarget.checked)}
        size="sm"
      />
    </Stack>
  );
};
